import styled from "styled-components";

export const PayerKycIframe = styled("iframe")`
  width: 100%;
  height: 800px;
  border: 0px;
`;
